import PropTypes from "prop-types";
import ModuleTableSort from "./renderSort";
import { tbalePaginatorSetting } from "./paginatorSetting";
import { system_table } from "../../service/system";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export default function ModuleTable({
  className = "",
  isLazy = true,
  isPaginator = true,
  options = {},
  hookOptions = {},
  screenOptions = null,
} = {}) {
  const { showGridlines = true } = options;
  const {
    rawTbData,
    tbData,
    setTbData,
    tbTotalRecords,
    tbFirstIndex,
    setTbFirstIndex,
    tbRows,
    setTbRows,
    tbColumns,
    pageAction,
    tbFootGroup,
    sortField,
    setSortField,
  } = hookOptions;

  const onPage = (e) => {
    const startIndex = e.first,
      rows = e.rows;

    // 同一頁面，不刷新
    if (startIndex === tbFirstIndex && rows === tbRows) return;

    setTbFirstIndex(startIndex);
    setTbRows(rows);

    if (pageAction) pageAction({ startIndex, rows });
  };

  return (
    <DataTable
      value={tbData}
      className={className}
      size="small"
      paginator={isPaginator}
      paginatorTemplate={tbalePaginatorSetting}
      footerColumnGroup={tbFootGroup}
      lazy={isLazy}
      first={tbFirstIndex}
      totalRecords={tbTotalRecords}
      onPage={onPage}
      rows={tbRows}
      emptyMessage={system_table.empty}
      showGridlines={showGridlines}
      scrollable={!!options.scrollable || screenOptions}
      scrollHeight={screenOptions ? screenOptions.height - 55 : "auto"}
      {...options}
    >
      {tbColumns
        ?.filter((item) => !item.isHidden)
        ?.map((col) => (
          <Column
            {...col}
            key={`${col.field}_${col.header}`}
            header={
              col.isSort ? (
                <div className="flex align-items-center">
                  {col.header}
                  <ModuleTableSort
                    field={col.key}
                    sortType={col.sortType}
                    sortField={sortField}
                    setSortField={setSortField}
                    rawTbData={rawTbData}
                    tbData={tbData}
                    setTbData={setTbData}
                  />
                </div>
              ) : (
                col.header
              )
            }
            frozen={!!col.frozen}
          />
        ))}
    </DataTable>
  );
}

ModuleTable.propTypes = {
  className: PropTypes.string,
  hookOptions: PropTypes.shape({
    rawTbData: PropTypes.array,
    tbData: PropTypes.array,
    setTbData: PropTypes.func,
    tbTotalRecords: PropTypes.number,
    tbFirstIndex: PropTypes.number,
    setTbFirstIndex: PropTypes.func,
    tbRows: PropTypes.number,
    setTbRows: PropTypes.func,
    tbColumns: PropTypes.array,
    pageAction: PropTypes.func,
    tbFootGroup: PropTypes.node,
    sortField: PropTypes.string,
    setSortField: PropTypes.func,
  }),
  isLazy: PropTypes.bool,
  isPaginator: PropTypes.bool,
  options: PropTypes.shape({
    scrollable: PropTypes.bool,
  }),
  screenOptions: PropTypes.shape({
    height: PropTypes.number,
  }),
};
